import * as React from 'react';

import { useRequest } from 'ahooks';
import { Col, Form, Input, Row } from 'antd';

import { PrimitiveTreeSelect } from 'components';
import { usePackagingModelAction, usePackagingModelValue } from 'context';
import { getCategories } from 'services';
import type { TreeSelectSource } from 'types';
import { generateTreeSelectData, inputRule, normalizeToString } from 'utils';

type FieldType = Pick<
  ReturnType<typeof usePackagingModelValue>,
  'name' | 'label' | 'helpText' | 'categories'
>;

const PackagingModelFormContent = () => {
  const { data: categoriesData, loading: categoriesLoading } = useRequest(
    getCategories,
    {
      cacheKey: 'categories',
    },
  );
  const { name, label, helpText, categories = [] } = usePackagingModelValue();
  const action = usePackagingModelAction();

  const totalCategories = categoriesData?.categories ?? [];

  const categoriesTreeData = generateTreeSelectData(
    totalCategories,
    'id',
    'title',
    'id',
  );

  return (
    <Row className='px-6 py-8'>
      <Col span={24} lg={12} className='lg:pe-3'>
        <Form.Item<FieldType>
          label='نام'
          name='name'
          rules={[inputRule.required, inputRule.string]}
          initialValue={name}
        >
          <Input placeholder='نام بسته‌بندی را وارد کنید' />
        </Form.Item>
      </Col>
      <Col span={24} lg={12} className='lg:ps-3'>
        <Form.Item<FieldType>
          label='برچسب'
          name='label'
          rules={[inputRule.required, inputRule.string]}
          initialValue={label}
        >
          <Input placeholder='برچسب بسته‌بندی را وارد کنید' />
        </Form.Item>
      </Col>
      <Col span={24}>
        <Form.Item<FieldType>
          label='توضیحات مختصر'
          name='helpText'
          rules={[inputRule.string, inputRule.abstraction]}
          initialValue={helpText}
        >
          <Input.TextArea
            autoSize
            placeholder='توضیحات مختصر بسته‌بندی را وارد کنید'
          />
        </Form.Item>
      </Col>
      <Col span={24}>
        <Form.Item<FieldType>
          label='دسته‌بندی‌ها'
          name='categories'
          initialValue={categories.map(({ id, title }) => ({
            key: id,
            label: title,
            value: id,
          }))}
        >
          <PrimitiveTreeSelect<TreeSelectSource[]>
            multiple
            treeCheckable
            treeCheckStrictly
            placeholder='دسته‌بندی‌های بسته‌بندی را انتخاب کنید'
            loading={categoriesLoading}
            treeData={categoriesTreeData}
            onChange={values => {
              action({
                type: 'UPDATE_PACKAGING_MODEL_CATEGORIES',
                payload: {
                  categories: values.map(({ label, value }) => ({
                    id: normalizeToString(value),
                    slug: normalizeToString(label),
                    subSlug: normalizeToString(label),
                    title: normalizeToString(label),
                    status: 'Active',
                    values: [],
                  })),
                },
              });
            }}
          />
        </Form.Item>
      </Col>
    </Row>
  );
};

export { PackagingModelFormContent };
